import type { FaireProductEntity } from "../../entity_types/product";

export const p_bqqexz428y: FaireProductEntity = {
  token: "p_bqqexz428y",
  type: "product",
  name: 'Green Oval "Thank You" Greeting Card',
  brandToken: "b_yjakje8bv3",
  brandName: "Casey Jo Paper Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/951958c22d42692c4a35edab6f5417779238b6db7f8273ec77caf53cfa5d1e0a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e861a4bb929989fd1e29a1d539e37d54e1c7f7fd2f286c2a7bf9a03ace54b74d.jpeg",
    "https://cdn.faire.com/fastly/9667326a4a594308af90ac76959456e9ac4d797486d5f375291bc554f35f2944.png",
    "https://cdn.faire.com/fastly/93bfc13d7e809c4c003995f6057f04b87cdb85c509e146b32a5a00fb464eead9.jpeg",
  ],
  priceDollars: 2.75,
  description:
    'Featuring an original watercolor oval and gold foil script, our Green Oval "Thank You" card is part of our Signature Collection — a timeless option for hostess gifts, weddings, teacher appreciation, and everyday gratitude.\n\n• Blank inside\n• Includes white euro flap envelope\n• A2 Size: 4.25" x 5.5"\n• Printed on high-quality, 120lb thick paper\n• Original watercolor artwork by Casey\n• Packaged in clear plastic sleeve\n• Made in the USA',
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:32.394Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
